module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 190 57.9",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }